var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement(
      "title",
      null,
      "Average"
    ),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M17.55 1.18v1.39a1.07 1.07 0 0 1-1.07 1.07H3.59a1.07 1.07 0 0 1-1.07-1.07V1.18A1.07 1.07 0 0 1 3.59.11h12.89a1.07 1.07 0 0 1 1.07 1.07zm-5 11.43l3.86-4.23a1 1 0 0 0-.07-1.46l-1.21-1.15a1 1 0 0 0-1.46.06L10 9.82l-3.64-4a1 1 0 0 0-1.43-.02L3.67 7a1 1 0 0 0-.06 1.46l3.86 4.19-4.13 4.49a1 1 0 0 0 .06 1.46l1.26 1.15a1 1 0 0 0 1.46-.06L10 15.4l4 4.26a1 1 0 0 0 1.46.06l1.26-1.16a1 1 0 0 0 .06-1.46z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Average.svg